module.exports = __webpack_public_path__ + "static/media/icon_angle-right-sm.72b44c34.svg";